module.exports = __webpack_public_path__ + "static/media/emotion_worried.87ed791c.svg";